import { Switch } from "@/components/ui/switch";
import { SectionHeading } from "@/components/vendor/Brand";

const COLS = ["Room Package / Max Size", "Typical Items Requiring Assembly", "Our Est.", "Your Rate / OK"];

const RoomRow = ({ room, value, onRate, onApprove }) => (
  <tr data-testid={`room-row-${room.id}`}>
    <td data-label={COLS[0]}>
      <div className="hx-strong">{room.label}</div>
      <div className="hx-muted">{room.size}</div>
    </td>
    <td data-label={COLS[1]}>{room.items}</td>
    <td data-label={COLS[2]} className="hx-est">{room.our_estimate}</td>
    <td data-label={COLS[3]}>
      <div className="hx-rate">
        <input
          className="hx-input"
          placeholder={value.approved ? "Using our estimate" : "Your rate, e.g. $200"}
          value={value.rate}
          disabled={value.approved}
          maxLength={60}
          onChange={(e) => onRate(room.id, e.target.value)}
          aria-label={`Your rate for ${room.label}`}
          data-testid={`room-rate-input-${room.id}`}
        />
        <label className={`hx-toggle ${value.approved ? "is-on" : ""}`}>
          <Switch
            checked={value.approved}
            onCheckedChange={(v) => onApprove(room.id, v)}
            className="data-[state=checked]:bg-[#5A776F] data-[state=unchecked]:bg-[#D5DCD9]"
            data-testid={`room-approve-toggle-${room.id}`}
          />
          Approve our estimate
        </label>
      </div>
    </td>
  </tr>
);

export const RoomPackagesTable = ({ rooms, values, onRate, onApprove }) => (
  <section className="hx-section" data-testid="room-packages-section">
    <SectionHeading>Room Packages</SectionHeading>
    <table className="hx-table hx-table--stack" data-testid="room-packages-table">
      <thead>
        <tr>{COLS.map((c) => <th key={c}>{c}</th>)}</tr>
      </thead>
      <tbody>
        {rooms.map((r) => (
          <RoomRow key={r.id} room={r} value={values[r.id]} onRate={onRate} onApprove={onApprove} />
        ))}
      </tbody>
    </table>
  </section>
);
